module.exports = __webpack_public_path__ + "img/fig-12.242ca9c9.png";